const DOCGRIDROUTES = {
  LOGIN: "/login",
  REGISTER: "/signUp",
  BRIEFCASE: "/briefcase",
  PROFILE: "/profile",
  SETTING: "/setting",
  ROLEPERMISSIONS: "/role-permissions/:id",
  EMP_PROFILE: "/profile/:id",
  EMPLOYEE: "/employee",
  ERROR: "/error",
  SSO_COMPLETE: "/sso/complete",
  SSO_SIGNED_OUT: "/sso/signed-out",
};

export default DOCGRIDROUTES;
